import { spring } from 'react-motion';

const initial = { stiffness: 320, damping: 28 };
const obj = ([nData, nPos], [infoData, infoPos]) => ({
  data: spring(nData, { ...infoData }),
  pos: spring(nPos, { ...infoPos }),
});

const animation = (prev) =>
  prev.map((_, i) =>
    i === 0 ? obj([1, 0], [initial, initial]) : obj([prev[i - 1].data, prev[i - 1].pos], [initial, initial]),
  );

export default animation;
